module.exports = __webpack_public_path__ + "img/kx5200-2.f85b5c52.png";